export default "__VITE_ASSET__CUpVHf_2__"